<!-- 

COMPONENTE PARA ANEXAR DOCUMENTOS


    <anexos-form v-if="showAnexosForm" :params="{ ref: 'item', chaveref: coditem, title: descricao, showForm: false }" @closeform="closeForm"></anexos-form>


params: { 
  ref: '',
  chaveref: '',
  title: '',
  showForm: false,
  }



 -->

<script>
import axios from 'axios'
import { apiORDS, apiORDSpost, apiORDSmidia, urlORDS } from '../shared/api-functions'

export default {
    props: {
      params: Object 
    },

    data () {
      return {
        mainImage: null, //imagem principal sendo exibida
        listImages: [],
        selectedIndex: 0,
        chaveref: '',
        ref: '',
      }
    },

    computed: {
      title: function () {
        //if (this.params.ref == 'item') { 
        if (this.fotosProduto && this.params.title) {
          return 'Imagens de ' + this.params.title
        } else {
          return 'Anexos'
        }
      },

      fotosProduto: function () {
        return ((this.params.ref == 'item') || (this.params.imagem))
      },

      fileTypes: function () {
        if (this.fotosProduto)
          return 'image/*'
        else
          return ''
      },
    },

    methods: {
      closeForm(action) {
        this.$emit('closeform')
      },

      handleClickGaleria (index) {
        this.mainImage = this.listImages[index].url
        this.selectedIndex = index
      },

      handleDelete (index) {
        this.apiDeleteAnexo(this.listImages[index].coddoc)

        this.listImages.splice(index, 1)
        
        if (index > 0) {
          this.mainImage = this.listImages[index-1].url
          this.selectedIndex = index-1
        } else {
          this.mainImage = null
        }
      },

      handleClickAdiciona () {
        document.getElementById('fileInput').click()
      },

      handleChange () {
        this.$emit('change', this.listImages)
      },

      handleUpload (event) {
          if (this.fotosProduto && event.target.files[0]['type']!=='image/jpeg' && event.target.files[0]['type']!=='image/png') {
            this.$erpToastError('Arquivo não permitido')
            return 
          }

          this.selectedFile = event.target.files[0] //this.$refs.file.files[0]
          // this.mainImage = URL.createObjectURL(this.selectedFile)
          let image = { image: this.mainImage, url: '', uploading: true }
          this.listImages.push(image)
          this.selectedIndex = this.listImages.length-1
          this.apiUploadAnexo()
      },

      async loadData() {
        //CARREGA IMAGENS
        await this.$store.dispatch('loadDocs', { id: this.ref + '/' + this.chaveref } )
        this.listImages = [...this.$store.getters.getDocsList]

        //EFETUA O DOWNLOAD DE CADA IMAGEM NA BARRA DE MINIATURAS
        if (this.params.showform) {
          for (var x = 0; x < this.listImages.length; x++) {
              this.$set(this.listImages[x], 'image', null)
              // this.loadMiniatura(x)
              if (x == 0)
                this.mainImage = this.listImages[x].url
          }
        }
      },

      async loadMiniatura(index) {
        let self = this
        let test = index
        await apiORDSmidia(this.listImages[index].url).then(
            (data) => {
                if (data && data.size > 0) {
                    let reader = new window.FileReader()
                    reader.readAsDataURL(data)
                    reader.onload = function() {
                        self.listImages[test].image = reader.result
                        if (test == 0) {
                          self.mainImage = reader.result
                        }
                    }
                }
            }
        )
      },

      apiUploadAnexo(){
          let formData = new FormData();
          formData.append('file', this.selectedFile);

          var url = this.$store.getters.urlOrds + 'docs/' 

          var self = this

          axios.post(url, formData,
              {
              headers: {
                  'Content-Type': 'multipart/form-data',
                  'ref': this.ref,
                  'chaveref': this.chaveref,
                  'filename': this.selectedFile.name
              }
          }
          ).then(function(response){
              if (response.data.items) {
                var x = self.listImages.length -1
                self.$set(self.listImages[x], 'coddoc', response.data.items[0].coddoc)
                self.$set(self.listImages[x], 'url', response.data.items[0].url)
                self.$set(self.listImages[x], 'filename', response.data.items[0].filename)
                self.$set(self.listImages[x], 'usuario_nome', response.data.items[0].usuario_nome)
                self.$set(self.listImages[x], 'data', response.data.items[0].data)
                self.$set(self.listImages[x], 'uploading', false)
                self.handleChange()
              }
              self.$erpToastSuccess('anexo atualizado')
          })

      },

      apiDeleteAnexo(coddoc){
          var url = this.$store.getters.urlOrds + 'docs/' + coddoc

          var self = this
          axios.delete(url).then(function(data){
            self.$erpToastSuccess('O anexo foi removido')
            self.handleChange()
          })

      },


    },

    created () {
      this.chaveref = this.params.chaveref
      this.ref = this.params.ref
      this.loadData()
    }
  
}
</script>

<template>
 
  <div class="w-100">
    <!-- LISTA -->
    <input v-show="false" id="fileInput" type="file" ref="file" :accept="fileTypes" @change="handleUpload($event)">

    <div v-if="!params.showform" class="" style="padding-left: 20px height: 20%">
        <div class="row mb-3 align-items-center" v-for="(img, index) in listImages" :key="index">
          <div class="col-md-1 text-center">
              <i class="fa fa-paperclip attach-icon"></i>
          </div>
          <div class="col-md-11" v-if="!img.uploading">
            <span class="lbl-list pr-3"><i class="fa fa-calendar pr-2" aria-hidden="true"></i> {{ img.data | formatDataExtenso }}</span>
            <span class="lbl-list pr-3"><i class="fa fa-user-circle pr-2" aria-hidden="true"></i> {{ img.usuario_nome }}</span>
            <div class="w-100">
              <a :href="img.url"> {{ img.filename }} </a>
            </div>
            <div class="w-100">
              <a href="javascript:void(0);" @click="handleDelete(index)"> <i class="fa fa-trash pr-2"></i>Remover</a>
            </div>
          </div>
          <div v-else class="col-md-11">
            <span class="lbl-list">Salvando...</span>
          </div>
        </div>
    </div>

    <!-- FORMULARIO DE IMAGENS -->
    <div v-if="params.showform" class="nb-modal-scrollable">
        <div class="container nb-modal-scrollable-container nb-email-container" style="height: 90%; overflow: auto">
            <div class="nb-modal-header">
                <h4 class="def-title">{{ title }}</h4>
                <button type="button" class="close" @click="closeForm()" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="nb-modal-scrollable-body" style="height: 70%">
              <div class="row text-center" style="height: 80%">
                  <div class="row align-items-center" style="width: 100%; height: 100%; padding: 10px;">
                      <img v-if="mainImage" :src="mainImage" style="max-height: 100%" class="mx-auto d-block justify-content-center">
                      <i v-if="!mainImage" class="fa fa-camera mx-auto d-block no-image" @click="handleClickAdiciona"></i>
                  </div>
              </div>
              <hr>
              
              <div class="row col" style="padding-left: 20px height: 20%">
                <div class="imagem-list text-center nb-margin-bottom" :class="{'active': selectedIndex == index}" v-for="(img, index) in listImages" :key="index">
                    <div v-if="!img.coddoc || !img.url" class="imagem-galeria-loading">
                      <div class="spinner-border text-muted"></div>
                    </div>
                    <img v-if="img.coddoc && img.url" class="imagem-galeria" :src="img.url" @click="handleClickGaleria(index)"><br>
                    <span v-if="img.coddoc && img.url" class="imagem-excluir" @click="handleDelete(index)">
                      <small><i class="fa fa-trash" aria-hidden="true"></i> Remover Imagem </small>
                    </span>
                </div>
                <div class="adicionar-imagem nb-margin-bottom" @click="handleClickAdiciona">
                    <i class="fa fa-plus"></i>
                    Anexar
                </div>
              </div>
            </div>
        </div>
    </div>
  </div>




</template>

<style>

.imagem-galeria {
    max-height: 80px;
    /* margin-right: 5px; */
}

.imagem-galeria-loading {
    height: 100%;
    width: 80px; 
    padding-top: 30px
}

.imagem-list {
    padding: 4px;
    background-color: #fff;
    border: 1px solid #ccc;
    border: 1px solid rgba(0,0,0,0.2);
    -webkit-box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    -moz-box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    box-shadow: 0 1px 3px rgba(0,0,0,0.1);
    margin-right: 5px
}

.imagem-list.active {
    background-color: #67a0be!important;
}

.imagem-excluir {
    cursor: pointer; 
    background: white; 
    border: 1px solid #ccc;
    padding: 4px;    
}

.no-image {
    font-size: 72px; 
    color: silver; 
    cursor: pointer  
}

.adicionar-imagem {
    min-height: 100px;
    width: 152px;
    padding: 38px 5px 5px;
    float: left;
    font-size: 18px;
    text-align: center;
    border: 1px dashed #bbb;
    color: #888;
    background-color: #fff;
    cursor: pointer;
}

.attach-icon {
    /* font-size: 24px; */
    color: #808080bb;  
}

</style>





// WEBPACK FOOTER //
// src/components/anexos-form.vue